// extracted by mini-css-extract-plugin
export var backButton = "survey-question-edit-module--back-button--GeMap";
export var buttons = "survey-question-edit-module--buttons--qBV+R";
export var container = "survey-question-edit-module--container--JbLBE";
export var sendButton = "survey-question-edit-module--send-button--1LGnm";